import { LOGOUT, REHYDRATE, CHOOSE_COMPANY } from "@Actions/types";

export default function reducer(
	state = {
		platforms: [],
	},
	action
) {
	const { payload, type } = action;
	switch (type) {
		case LOGOUT: {
			return {
				...state,
				platforms: [],
			};
		}

		case REHYDRATE: {
			return {
				...state,
				platforms: payload.data.platforms.platforms,
			};
		}

		case CHOOSE_COMPANY: {
			return {
				...state,
				platforms: payload.data.platforms,
			};
		}

		default:
			return state;
	}
}
